// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ProjectProvider } from './context/ProjectContext';

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  // Dok provjeravamo jeste li ulogirani (isAuthenticated je null), prikazujemo kratko učitavanje
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900 text-slate-400 font-sans text-sm font-semibold">
        Učitavanje sustava...
      </div>
    );
  }

  return (
    <Routes>
      {/* Ako je korisnik već ulogiran, preusmjeri ga s /login na početnu */}
      <Route 
        path="/login" 
        element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} 
      />

      {/* Ako je korisnik ulogiran dopuštamo pristup, inače šaljemo na login */}
      <Route 
        path="/*" 
        element={isAuthenticated ? <MainLayout /> : <Navigate to="/login" replace />} 
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <ProjectProvider>
        <Router>
          <AppRoutes />
        </Router>
      </ProjectProvider>
    </AuthProvider>
  );
}